<template>
    <div class="content-wrap">
        <section class="section section-highlight content-section-02">
            <div class="container">
                <div class="row middle-gi">
                    <div class="col-xs-12 col-md-4">
                        <div class="section-image">
                            <img src="../assets/smartphone-image.webp" alt="Was ist dein Gebrauchtwagen wert?" />
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-8 text-wrapper">
                        <h3 class="headline_h2 bordered-heading">Was ist mein Auto wert?</h3>
                        <p class="text-margin text">Den Fahrzeugwert des eigenen Autos realistisch einschätzen, ist gar nicht so leicht. Klar: ein hoher Kilometerstand kann den Restwert drücken, Autos mit Klimaanlage und Xenon-Scheinwerfern verkaufen sich besser. Unser Algorithmus berechnet anhand von über 60 Ausstattungsmerkmalen und 1.8 Millionen Datensätzen deine individuelle Autobewertung.</p>
                        <p class="text-margin text">Dazu benötigen wir Marke, Modellbezeichnung und das Datum der Erstzulassung. Mit weiteren Merkmalen wie Kraftstoffart, Getriebe und Ausstattung kann unsere TÜV-Rheinland-zertifizierte Fahrzeugbewertung starten. Du erhältst deine Autobewertung bequem per E-Mail, kostenlos und unverbindlich.</p>
                        <p class="text-margin text">Übrigens: In einigen Fällen kann es vorkommen, dass unser Algorithmus dein Auto nicht auf Anhieb bewerten kann. Wenn du zum Beispiel ein älteres Modell mit ungewöhnlicher Ausstattung fährst, fehlen die nötigen Vergleichswerte - trotz Millionen Datensätzen. Kein Problem: Denn wenn du dein Auto bewerten möchtest, um es zu verkaufen, helfen dir unsere PKW.de-Experten dabei, einen realistischen Wert für dein Fahrzeug zu ermitteln.</p>
                        <button class="text-wrapper__btn" @click="makeRedirect">Auto bewerten kostenlos <i class="fas fa-arrow-right" /> </button>
                    </div>
                </div>
            </div>
        </section>
        <section class="section content-section-02 second-section">
            <div class="container">
                <div class="row middle-gi">
                    <div class="col-xs-12 col-md-8 text-wrapper">
                        <h3 class="headline_h2 bordered-heading margin-bottom">Auto geerbt - was nun?</h3>
                        <p class="text-margin text">Nicht nur beim Verkauf ist es oft wichtig, eine faire, akkurate und schnelle Fahrzeugbewertung zu erhalten. Unsere TÜV-Rheinland-zertifizierte Fahrzeugbewertung erhältst du nach wenigen Klicks in per E-Mail. So können sich Erben im Trauerfall unkompliziert einen Eindruck über den Wert des Autos machen und alles Weitere ohne Druck entscheiden.</p>
                        <h3 class="headline_h2 bordered-heading margin-top margin-bottom">Hartz 4 und Bürgergeld - Auto behalten?</h3>
                        <p class="text-margin text">Mit der Einführung des Bürgergeldes und dem Ende des Arbeitslosengeld 2 (Hartz 4) 2023 haben sich die Voraussetzungen für Autofahrer geändert. Die Regelungen bei Hartz 4 waren eindeutig: Ein Auto durfte maximal 7.500 Euro wert sein, sonst musste es verkauft und das eingenommene Geld für den Lebensunterhalt verwendet werden.</p>
                        <p class="text-margin text">Beim Bürgergeld wird der “angemessene Wert” des Autos nur in Ausnahmefällen geprüft. Restwerte über 7.500 Euro fallen gegebenenfalls ins deutlich höhere Schonvermögen - im ersten Jahr des Bürgergeldbezugs 40.000 Euro plus 15.000 Euro für jedes weitere Haushaltsmitglied. Nach der sogenannten Karenzzeit von einem Jahr gilt ein Schonvermögen von 15.000 Euro pro Person in der Bedarfsgemeinschaft.</p>
                        <button class="text-wrapper__btn" @click="makeRedirect">Auto bewerten kostenlos <i class="fas fa-arrow-right" /> </button>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="section-image">
                            <img src="../assets/car-coins.webp" alt="Was ist dein Gebrauchtwagen wert?" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { redirectToEvaluation } from '../services/helpers';

export default {
    name: "ContentBlock",
    methods: {
        makeRedirect() {        
            redirectToEvaluation(this.$store);
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/vars";

    .content-wrap .text-wrapper {

        &__btn i {
            padding-left: 10px;
        }
        .text-margin {
            margin-bottom: 30px;
        }
    }
    .section {
        padding:30px 0;

        @include breakpoint(frommediumlarge) {
             padding:54px 0;
        }

        @include breakpoint(fromgiant) {
             padding:100px 0;
        }

        
        &.section-highlight {
            background:$light-gray;

            @include breakpoint(fromgiant) {
             padding:74px 0;
        }
        }

        .margin-top {
            margin-top:16px;
            
            @include breakpoint(fromgiant) {
                margin-top:42px;
            }
        }
        .margin-bottom {
            margin-bottom:16px;
            
            @include breakpoint(fromgiant) {
                margin-bottom:42px;
            }
        }

        

        &.content-section-01 {
            @include breakpoint(frommediumlarge) {
                padding-top:0;
            }
            @include breakpoint(fromgiant) {
                padding-top:50px;
            }
            h2 {
                br {
                    @include breakpoint(frommediumlarge) {
                        display:none;
                    }
                    @include breakpoint(fromlarge) {
                        display:block;
                    }
                }
            }
            .car-image {
                max-width:350px;
                margin-top:10px;

                @include breakpoint(frommediumlarge) {
                    margin-top:0;
                    max-width:90%;
                }
            }
        }
        &.content-section-02 {
            .section-image {
                img {
                    width: 100%;
                    max-width:400px;
                    display:block;
                    margin:0 auto 20px;

                    @include breakpoint(frommediumlarge) {
                        margin:0;
                        max-width:100%;
                    }
                }
            }

            &.second-section {
                .text-wrapper__btn {
                    display: none !important;

                    @include breakpoint(frommediumlarge) {
                        display: inline-block !important;
                    }
                }
            }
        }

        &.content-section-03 {
            br {
                display:none;

                @include breakpoint(frommediumlarge) {
                    display: block;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/landing-components/ContentBlock.vue